export var ExclusionResult;
(function (ExclusionResult) {
    ExclusionResult["SUCCESS"] = "SUCCESS";
    ExclusionResult["SELF_EXCLUDED"] = "SELF_EXCLUDED";
    ExclusionResult["REJECTED"] = "REJECTED";
})(ExclusionResult || (ExclusionResult = {}));
//# sourceMappingURL=exclusion-result.js.map